import { PromotionTypeEnum } from "../types/common";

/**
 * Whether a bid carries the EU-loan promotion, which recolours the promotion
 * strip to EU blue and adds the flag. Lives in shared because both the customer
 * dashboard and the lender portal render that strip, and the lender app must not
 * import from customer-features.
 *
 * Structurally typed so it accepts both the customer `IPromotion` (a saved
 * promotion) and the lender `IPromotionInput` (an unsaved form value).
 */
export const hasEuLoanPromotion = (
  promotions?: { type: PromotionTypeEnum }[] | null,
): boolean =>
  !!promotions?.some(
    (promotion) => promotion.type === PromotionTypeEnum.EU_LOAN,
  );

/**
 * The promotions OTHER than EU_LOAN. The strip labels these with the
 * "Special offer:" prefix, while EU_LOAN stands on its own — it names a kind of
 * loan rather than a limited-time offer, so the prefix would misdescribe it.
 */
export const withoutEuLoanPromotion = <T extends { type: PromotionTypeEnum }>(
  promotions?: T[] | null,
): T[] =>
  (promotions ?? []).filter(
    (promotion) => promotion.type !== PromotionTypeEnum.EU_LOAN,
  );
